const IsProduction = ({ children }: { children: React.ReactNode }) => {
  const isProd = process.env.NODE_ENV === 'production';
  return isProd ? children : null;
};

export { IsProduction };
